import {ref} from "vue";

export default () => {
    const isOnline = ref(navigator.onLine);
    window.addEventListener("online", () => {
        console.log(navigator.onLine);
        isOnline.value = true;
    });
    window.addEventListener("offline", () => {
        console.log(navigator.onLine);
        isOnline.value = false;
    });
    return isOnline;
};
